import React, { useCallback, useMemo } from "react";
import SelectGroup from "../../witadmin/CRUD/Common/SelectGroup";
import styled from "styled-components";
import { getLocaleList } from "../../../lib/intlUtils";
import { InputWidgetProps } from ".";
import { defineMessages, FormattedMessage } from "react-intl";

export const messages = defineMessages({
  helperText: {
    id: "localeSelector.helperText.reference",
    defaultMessage: "reference",
  },
});

const SelectGroupWrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 200px;
  margin-bottom: -20px;
`;

export function LocaleSelector({ value, onChange, schema }: InputWidgetProps) {
  const localeList = useMemo(() => {
    return getLocaleList().reduce((accum, curr) => {
      return {
        [curr]: { label: curr },
        ...accum,
      };
    }, {});
  }, []);

  const handleChange = useCallback(
    event => {
      onChange(event.target.value);
    },
    [onChange]
  );

  return (
    <SelectGroupWrapper>
      <SelectGroup
        value={value}
        field={{
          fieldName: "type",
          widget: "selector",
          optionDisplay: localeList,
        }}
        onChange={({ event, field }) => {
          handleChange(event);
        }}
        errors={undefined}
        additionalFields={undefined}
        className={undefined}
      />
      <a
        style={{ display: "block", marginTop: -10, marginBottom: 15 }}
        target="_blank"
        rel="noreferrer"
        href="https://en.wikipedia.org/wiki/List_of_ISO_639_language_codes">
        <FormattedMessage {...messages.helperText} />
      </a>
    </SelectGroupWrapper>
  );
}
